import { jsx as _jsx } from "react/jsx-runtime";
const PlusIcon = (props) => {
    return (_jsx("svg", Object.assign({ width: "100%", height: "100%", viewBox: "0 0 14 14", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("g", Object.assign({ id: "plus" }, { children: _jsx("path", { id: "Vector", d: "M11.0837 7.58366H7.58366V11.0837H6.41699V7.58366H2.91699V6.41699H6.41699V2.91699H7.58366V6.41699H11.0837V7.58366Z", fill: props.color }) })) })));
};
PlusIcon.defaultProps = {
    color: 'white',
};
export default PlusIcon;
